// extracted by mini-css-extract-plugin
export default {"button":"share_button__3h8Ik","socials":"share_socials__l6SLs","share_button":"share_share_button__CBlGE"};